export const LARGE_LOADER_SIZE = 70;
export const LARGE_LOADER_THICKNESS = 6;
export const MEDIUM_LOADER_SIZE = 50;
export const MEDIUM_LOADER_THICKNESS = 4;
export const SMALL_LOADER_SIZE = 20;
export const SMALL_LOADER_THICKNESS = 2;
